import Cookies from "js-cookie";

export const DEFAULT_LANG = "vi";
export const LEVEL_EASY = 1;
export const LEVEL_MEDIUM = 2;
export const LEVEL_HARD = 3;
export const CODE_422 = 422;
// Response code forgot password fail
export const CODE_4030 = 4030;
export const STATUS_PENDING = 0;
export const STATUS_FALSE = 1;
export const STATUS_CORRECT = 2;
export const PAGE_NEED_AUTH = [
    "categories.index",
    "categories.edit",
    "problems.index",
    "AdminProblem",
    "CreateProblem",
    "EditProblem",
    "ListUserAnswer",
    "DetailUserAnswer",
    "QuestionList",
    "TeacherList",
];

export const SIDEBAR_ITEMS = [
    {
        label: "sidebar.lable_user",
        to: "/admin",
        name: "TeacherList",
        permission: "admin",
        icon: "bag",
        isShow: "true",
        role: [1]
    },
    {
        label: "sidebar.question",
        permission: "teacher",
        icon: "bag",
        isShow: "true",
        role: [1, 2, 3, 4, 6, 8],
        children: [
            {
                label: "sidebar.question_list",
                permission: "teacher",
                name: "QuestionList",
                to: "/admin/question-list/question",
                isShow: "true",
                role: [1, 2, 3, 4, 6, 8]
            },
            {
                label: "sidebar.group_topic_list",
                permission: "teacher",
                to: "/admin/group-topic-list",
                isShow: "true",
                role: [1, 2, 3, 4, 8]
            }
        ]
    },
    {
        label: "sidebar.exam_management",
        permission: "teacher",
        to: "/admin/exam/list",
        icon: "file-earmark",
        isShow: "true",
        role: [1, 2, 3, 4, 7, 8]
    },
    {
        label: "sidebar.paperslist",
        permission: "teacher",
        icon: "file-earmark",
        isShow: "true",
        role: [1, 2, 3, 4, 8],
        children: [
            {
                label: "sidebar.examStudent",
                permission: "teacher",
                to: "/exam/student-list",
                icon: "file-earmark",
                name:"ExamStudentList",
                isShow: "true",
                role: [6]
            },
            {
                label: "sidebar.paperslist",
                permission: "teacher",
                to: "/admin/exam/papers-list",
                isShow: "true",
                role: [1, 2, 3, 4, 8]
            },
            {
                label: "sidebar.examStudentDetail",
                permission: "teacher",
                to: "/exam/student-detail",
                icon: "file-earmark",
                name:"ExamStudentDetail",
                isShow: "true",
                role: [6]
            },
            {
                label: "sidebar.examResult",
                permission: "teacher",
                to: "/admin/exam/student-result",
                isShow: "true",
                role: [1, 2, 3, 4, 8]
            },

        ]
    },
    {
        label: "sidebar.setting",
        permission: "teacher",
        icon: "people",
        isShow: "true",
        role: [1, 2, 3, 4, 8],
        children: [
            {
                label: "sidebar.difficulty",
                permission: "teacher",
                to: "/admin/config/difficulty",
                isShow: "true",
                role: [1, 2, 3, 4]
            },
            {
                label: "sidebar.category",
                permission: "teacher",
                to: "/admin/config/category",
                isShow: "true",
                role: [1, 2, 3, 4, 8]
            },
            {
                label: "sidebar.grade",
                permission: "teacher",
                to: "/admin/config/grade",
                isShow: "true",
                role: [1, 2, 3, 4]
            },
            {
                label: "sidebar.limitTimeToPlay",
                permission: "teacher",
                to: "/admin/config/logo",
                isShow: "true",
                role: [1, 2, 3, 4]
            }
        ]
    },
    {
        label: "sidebar.exam_list",
        permission: "student",
        icon: "bag",
        isShow: "true",
        role: [5],
        children: [
            {
                label: "sidebar.home_page",
                permission: "student",
                to: "/student/exam/list",
                icon: "house-door",
                name: "ExamStudent",
                isShow: "true",
                role: [5]
            },
            {
                label: "sidebar.my_exam",
                permission: "student",
                to: "/student/exam/my-exam",
                icon: "file-earmark",
                name: "MyExam",
                isShow: "true",
                role: [5]
            }
        ]
    },
    {
        label: "payment.label.payment",
        to: "/admin/payment",
        icon: "credit-card",
        name: "Payment",
        permission: "admin",
        role: [1]
    },
    {
        label: "sidebar.logout",
        to: "/login",
        icon: "box-arrow-right",
        isShow: "true",
        role: [5]
    },
    {
        label: "sidebar.logout",
        to: "/admin/login",
        icon: "box-arrow-right",
        isShow: "true",
        role: [1,2,3,4,6,7]
    },
    // {
    //     permission: "student",
    //     to: "/student/exam/tryExam",
    //     icon: "file-earmark",
    //     name:"TryExam",
    //     isShow: "false"
    // },
]
export const ROUTE_GUEST = [
    "Home",
    "GroupTopicList",
    "QuestionList",
    "ExamList",
    "Grade",
    "SetTimes",
    "Category",
    "About",
    "Difficulty",
    "Profile",
    "Login",
    "LoginStudent",
    "Forgot",
    "Signup",
    "ResetPassword",
    "UserProblemDetail",
    "404",
    "403",
    "ListPapers",
    "ExamStudentList",
    "ExamStudentDetail",
    "ExamStudentResult",
    "ExamStudentResultDetail",
    "Payment",
    "Verify"
];

export const ROUTE_STUDENT = [
    "ExamStudent",
    "MyCart",
    "MyExam",
    "MyExamResult",
    "TryExam",
    "BuyExam",
    "VNPay",
    "Momo",
    "404",
    "403",
    "Login",
    "LoginStudent"
]

export const ROUTE_BUSINESS_STUDENT = [
    "MyExam",
    "MyExamResult",
    "TryExam",
    "404",
    "403",
    "Login",
    "LoginStudent"
]
